import { LogService } from '../services/log.service';

export class Workflow {
  private inProgress = false;
  private name: string;
  private log: LogService;

  hasMFAChallenge: boolean;
  hasNewPasswordChallenge: boolean;
  authenticatedResponse?: any;

  constructor(name: string, log: LogService) {
    this.name = name;
    this.log = log;
  }

  getName(): string {
    return this.name;
  }

  isInProgress(): boolean {
    this.log.trace('Workflow.isInProgress', this);
    return this.inProgress;
  }

  start() {
    this.log.trace('Workflow.start', this);
    this.inProgress = true;
  }

  end() {
    this.log.trace('Workflow.end', this);
    this.inProgress = false;
  }
}
